"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTournamentSpectateEnabled = void 0;
const game_1 = require("../../../modules/game");
const isTournamentSpectateEnabled = (tournament) => {
    var _a, _b;
    if (!tournament)
        return false;
    const [platformType, gameName] = [(_a = tournament === null || tournament === void 0 ? void 0 : tournament.game) === null || _a === void 0 ? void 0 : _a.platformType, (_b = tournament === null || tournament === void 0 ? void 0 : tournament.game) === null || _b === void 0 ? void 0 : _b.name];
    if (platformType === game_1.PlatformType.LeagueOfLegends) {
        return true;
    }
    if (platformType === game_1.PlatformType.Papergames) {
        return [game_1.GameName.Connect4, game_1.GameName.Gomoku].includes(gameName);
    }
    if (platformType === game_1.PlatformType.Lichess) {
        return true;
    }
    return false;
};
exports.isTournamentSpectateEnabled = isTournamentSpectateEnabled;
//# sourceMappingURL=tournament-spectate-utils.js.map